import { useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';
import { BillingStatus } from 'src/models/account/interfaces';
import { getDaysAndHoursLeft, getTrialDuration } from 'src/lib/utils/billing';

export const useTrialModal = (subscription: any) => {
	const {
		isOpen: isTrialModalOpen,
		onOpen: onTrialModalOpen,
		onClose: onTrialModalClose,
	} = useDisclosure();

	useEffect(() => {
		if (!subscription) return;

		const showTrialEndingModal =
			subscription.billingStatus === BillingStatus.Trial ||
			subscription.billingStatus === BillingStatus.TrialExpired ||
			subscription.billingStatus === BillingStatus.Inactive;

		if (!showTrialEndingModal) return;

		const freeTrialEnd = new Date(subscription.freeTrialEnd);
		const trialStart = new Date(subscription.startDate);
		const trialDuration = getTrialDuration(trialStart, freeTrialEnd);
		const hasPaymentMethod = Boolean(subscription.paymentMethod?.card?.last4);
		const { days: daysLeft } = getDaysAndHoursLeft(freeTrialEnd);

		const today = new Date().toISOString().split('T')[0];
		const lastShownDate = localStorage.getItem('trialModalLastShown');

		const shouldOpenTrialModal =
			subscription.billingStatus === BillingStatus.Trial &&
			daysLeft !== trialDuration &&
			!hasPaymentMethod &&
			lastShownDate !== today;

		const isTrialExpiredOrInactive =
			subscription.billingStatus === BillingStatus.TrialExpired ||
			subscription.billingStatus === BillingStatus.Inactive;

		if (shouldOpenTrialModal) {
			localStorage.setItem('trialModalLastShown', today);
			onTrialModalOpen();
		} else if (isTrialExpiredOrInactive) {
			onTrialModalOpen();
		}
	}, [subscription?.billingStatus, onTrialModalOpen]);

	return {
		isTrialModalOpen,
		onTrialModalClose,
	};
};
